export const EVENT_CATEGORY_ORDER = ['sport', 'party', 'gaming', 'hangout', 'trip', 'other'];

export const EVENT_CATEGORY_COLORS = {
  sport: '#c2410c',
  party: '#a855f7',
  gaming: '#6366f1',
  hangout: '#ea6820',
  trip: '#b45309',
  other: '#78716c',
  showAll: '#ea6820',
  create: '#fd7651',
};

export const EVENT_CATEGORY_SOFT_COLORS = {
  sport: 'rgba(194, 65, 12, 0.22)',
  party: 'rgba(168, 85, 247, 0.22)',
  gaming: 'rgba(99, 102, 241, 0.22)',
  hangout: 'rgba(234, 104, 32, 0.22)',
  trip: 'rgba(180, 83, 9, 0.2)',
  other: 'rgba(120, 113, 108, 0.18)',
  showAll: 'rgba(234, 104, 32, 0.2)',
  create: 'rgba(253, 118, 81, 0.22)',
};

export function getEventCategoryVisual(type) {
  const key = EVENT_CATEGORY_COLORS[type] ? type : 'other';
  return {
    key,
    color: EVENT_CATEGORY_COLORS[key],
    softColor: EVENT_CATEGORY_SOFT_COLORS[key],
  };
}

